import React, { Fragment } from "react";

import * as R from "ramda";

import { A, Box, Markup, Text } from "src/components";
import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

import { format, isSameDay, isFuture } from "date-fns";

const Strong = ({ children }) => (
  <span style={{ fontWeight: "500" }}>{children}</span>
);

const dayFormat = "MMMM D, YYYY";
const timeFormat = "h:mm a";
const dayTimeFormat = R.join(" [at] ", [dayFormat, timeFormat]);

const getNextEventDate = R.pipe(
  R.propOr([], "eventDates"),
  R.filter(R.pipe(R.prop("startDate"), isFuture)),
  R.sort(R.ascend(R.prop("startDate"))),
  R.head
);

const eventSubLabel = event => {
  const nextDate = getNextEventDate(event);

  if (nextDate) {
    return (
      <Fragment>
        Next event: <EventDateLabel {...nextDate} />
      </Fragment>
    );
  }
};

const eventDateToString = ({ startDate, endDate }) => {
  if (isSameDay(startDate, endDate)) {
    return `<strong>${format(startDate, dayFormat)}</strong> 
    from <strong>${format(startDate, timeFormat)}</strong> to
    <strong>${format(endDate, timeFormat)}</strong>
    `;
  }

  return `<strong>${format(startDate, dayTimeFormat)}</strong> to{" "}
  <strong>${format(endDate, dayTimeFormat)}</strong>`;
};

const EventDateLabel = eventDate => (
  <span dangerouslySetInnerHTML={{ __html: eventDateToString(eventDate) }} />
);

const fields = ({ events }) => ({ t }) => [
  {
    type: "section",
    title: t("forms.ContactInformationSectionTitle"),
    fields: contactFields({ t }),
  },
  {
    type: "section",
    title: t("forms.EventSectionTitle"),
    fields: [
      {
        key: "attendees",
        label: t("forms.events.attendeesCount"),
        required: true,
        defaultValue: 1,
      },
      {
        key: "event",
        label: t("forms.events.eventName"),
        type: "dropdown",
        required: true,
        inputProps: {
          valueToString: value => {
            if (value) {
              return R.pipe(R.find(R.propEq("slug", value)), R.prop("name"))(
                events
              );
            }
          },
          options: R.map(
            event => ({
              id: event.id,
              value: event.slug,
              label: event.name,
              subLabel: eventSubLabel(event),
            }),
            events
          ),
        },
      },
    ],
  },
];

const EventConfirmation = ({ event }) => {
  const eventDate = getNextEventDate(event);

  return (
    <Box>
      <Markup
        html={R.path(
          ["registrationConfirmation", "childMarkdownRemark", "html"],
          event
        )}
        values={{
          eventDate: eventDateToString(eventDate),
          directionsLink:
            event.location &&
            `<a
              href="https://www.google.com/maps/dir/${event.location.lat},${
              event.location.lon
            }"}
              target="_blank"
            >Directions</a>`,
        }}
      />
    </Box>
  );
};

const findEvent = (event, events) => R.find(R.propEq("slug", event), events);

const renderConfirmation = props => (
  <EventConfirmation
    {...props}
    event={findEvent(props.values.event, props.siteData.events)}
  />
);

const EventRSVPForm = ({ moduleKey, siteData }) => (
  <DynamicForm
    formKey={moduleKey}
    fields={fields(siteData)}
    renderConfirmation={props => renderConfirmation({ ...props, siteData })}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default EventRSVPForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/EventRSVPForm.js